<template>
  <div class="collapsible-text-field" :data-testid="dataTestId">
    <div
      v-if="!isExpanded"
      class="collapsible-text-field__collapsed d-flex align-center"
      :data-testid="`${dataTestId}__collapsed`"
    >
      <span class="collapsible-text-field__label">{{ label }}</span>
      <v-btn
        icon
        small
        class="collapsible-text-field__expand-btn"
        :aria-label="`Add ${label}`"
        :data-testid="`${dataTestId}__expand-btn`"
        @click="setExpanded(true)"
      >
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </div>

    <div
      v-else
      class="collapsible-text-field__expanded"
      :data-testid="`${dataTestId}__expanded`"
    >
      <div class="collapsible-text-field__header d-flex align-center justify-space-between">
        <span class="collapsible-text-field__label">{{ label }}</span>
        <div class="d-flex align-center">
          <v-btn
            icon
            small
            class="collapsible-text-field__collapse-btn"
            :aria-label="`Collapse ${label}`"
            :data-testid="`${dataTestId}__collapse-btn`"
            @click="setExpanded(false)"
          >
            <v-icon small>mdi-minus</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="collapsible-text-field__input-row d-flex align-center">
        <lb-string
          :label="label"
          :value="value"
          class="collapsible-text-field__input flex-grow-1"
          :data-testid="`${dataTestId}__input`"
          @input="onInput"
        />
        <v-btn
          v-if="hasValue"
          icon
          small
          class="collapsible-text-field__clear-btn ml-1"
          :aria-label="`Clear ${label}`"
          :data-testid="`${dataTestId}__clear-btn`"
          @click="onClear"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import './CollapsibleTextField.scss';

/** Optional collapsible text field — collapsed shows label + expand (5782 Add Task). */
export default {
  name: 'CollapsibleTextField',

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    dataTestId: {
      type: String,
      default: 'collapsible-text-field',
    },
  },

  computed: {
    isExpanded: {
      get() {
        return this.expanded;
      },
      set(next) {
        this.$emit('update:expanded', next);
      },
    },

    hasValue() {
      return Boolean((this.value || '').trim());
    },
  },

  methods: {
    setExpanded(next) {
      this.isExpanded = next;
    },

    onInput(nextValue) {
      this.$emit('input', nextValue);
    },

    onClear() {
      this.$emit('input', '');
    },
  },
};
</script>
